import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { class_type, int32_type, list_type, equals, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ValidatedUrlModule_value as ValidatedUrlModule_value_1, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { isNullOrEmpty, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { modalMain, modalCancel, ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { cons, isEmpty, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { ModalSize, getModalContainer, modal, getModalBodyContainer, getModalFooterContainer, getModalHeader } from "../../Components/Modal/Modal.js";
import { dotsLoading } from "../../ViewUtils.js";
import { warning, error } from "../../Components/Message/Message.js";
import { SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import "../../../src/Containers/CreateDocumentButton/View.scss";


class TemplateDTO extends Record {
    constructor(Templatename) {
        super();
        this.Templatename = Templatename;
    }
}

function TemplateDTO$reflection() {
    return record_type("Containers.CreateDocumentButton.View.TemplateDTO", [], TemplateDTO, () => [["Templatename", string_type]]);
}

function Api_loadPdfTemplates(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("SYSTEM/template/%i"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(TemplateDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TemplateDTO$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(TemplateDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export class DownloadPDFModelProps extends Record {
    constructor(ClientNr, InvoiceeNr, ContractNr) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = (ContractNr | 0);
    }
}

export function DownloadPDFModelProps$reflection() {
    return record_type("Containers.CreateDocumentButton.View.DownloadPDFModelProps", [], DownloadPDFModelProps, () => [["ClientNr", int32_type], ["InvoiceeNr", class_type("System.Int64")], ["ContractNr", int32_type]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, arg_5, children_4, children_2, children_7;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalOpenState = react.useState(false);
    const selectedPdfTemplateState = react.useState("");
    const pdfTemplatesState = react.useState(new LoadState$2(0));
    const buttonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateDocument"), defaultProps.Content, (_arg_1) => {
        pdfTemplatesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(Api_loadPdfTemplates(props.ClientNr), (_arg) => {
            const result = _arg;
            const arg_1 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, map((t) => t.Templatename, result.fields[0])));
            pdfTemplatesState[1](arg_1);
            return singleton.Zero();
        })));
        modalOpenState[1](true);
    }, defaultProps.Disabled, "create-document-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
    let modalHtml;
    const modalHeaderHtml = getModalHeader(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateDocument"), (_arg_2) => {
        modalOpenState[1](false);
    });
    let selectDocumentDropDownHtml;
    const matchValue = pdfTemplatesState[0];
    selectDocumentDropDownHtml = ((matchValue.tag === 1) ? dotsLoading : ((matchValue.tag === 3) ? error(matchValue.fields[0].split("")) : ((matchValue.tag === 2) ? (isEmpty(matchValue.fields[0]) ? warning(getTranslation("Containers.DownloadPDF.ThereAreNoTemplates").split("")) : selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp_1(0, selectedPdfTemplateState[0], (e) => {
        selectedPdfTemplateState[1](Browser_Types_Event__Event_get_Value(e));
    }), "download-pdf-choose-template", cons(["", getTranslation("Common.Choose")], map((x) => [x, x], matchValue.fields[0])), inputRecord.Classes, getTranslation("ChooseTemplate"), false, inputRecord.HTMLProps)))) : react.createElement(react.Fragment, {}))));
    let downloadLinkResult;
    const matchValue_1 = ValidatedUrlModule_create(new UrlKind(0, (arg_5 = (selectedPdfTemplateState[0]), toText(printf("/Template/%i/%i/%s"))(props.ClientNr)(props.ContractNr)(arg_5))));
    downloadLinkResult = ((matchValue_1.tag === 1) ? (new FSharpResult$2(1, toText(printf("Cant create url. Error msg: %s"))(matchValue_1.fields[0]))) : (new FSharpResult$2(0, ValidatedUrlModule_value_1(matchValue_1.fields[0]))));
    const errorMsgHtml = (downloadLinkResult.tag === 1) ? error(downloadLinkResult.fields[0].split("")) : react.createElement(react.Fragment, {});
    let footerHtml;
    const downloadLinkStr = (downloadLinkResult.tag === 1) ? "" : downloadLinkResult.fields[0];
    footerHtml = getModalFooterContainer((children_4 = [modalCancel(new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_3) => {
        modalOpenState[1](false);
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), (children_2 = [modalMain(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateDocument"), defaultProps.Content, (_arg_4) => {
        modalOpenState[1](false);
    }, isNullOrEmpty(selectedPdfTemplateState[0]), defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("a", {
        className: "w-100",
        href: downloadLinkStr,
        target: "_blank",
    }, ...children_2))], react.createElement(react.Fragment, {}, ...children_4)));
    const modalBodyHtml = getModalBodyContainer((children_7 = [react.createElement("div", {
        className: "fit-content",
    }, selectDocumentDropDownHtml), errorMsgHtml], react.createElement("div", {
        className: "d-flex mb-2",
    }, ...children_7)));
    const modalContents = react.createElement("div", {
        className: "download-pdf",
    }, modalHeaderHtml, modalBodyHtml, footerHtml);
    modalHtml = modal(modalOpenState[0], getModalContainer(new ModalSize(1), modalContents));
    return react.createElement("div", {
        id: "create-document-button-container",
    }, buttonHtml, modalHtml);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\CreateDocumentButton\\View.fs", 137);

